export enum Nav {
    ROOT = '/',
    MANAGER_CREATE_STORY = '/manager/create',
    NOT_FOUND = '*',
    SIGNIN = '/login',
    PROMOTIONS = '/promotions',
    PROMOTION_EDIT = '/promotions/edit/*',
    PROMOTION_ITEM = '/promotions/item/*',
    PROMOTION_ITEM_PRIZE = '/promotions/prize/*',
    PROMOTION_CREATE = '/promotions/create',
    REPORTS = '/reports',
    REPORTS_USERS = '/reports/users',
    REPORTS_ACTIVITY = '/reports/activity',
    REPORTS_SOCIAL = '/reports/social',
    REPORTS_COMMENTS = '/comments',
    PROFILE = '/profile',
    WORLD = '/stories/world/*',
    HOME = '/home',
    STORIES = '/stories',
    STORY = '/stories/story/*',
    SETTINGS = '/settings',
    EMAIL = '/settings/email',
    CODE = '/settings/ecode',
    PHONE = '/settings/phone',
    ADDRESS = '/settings/address',
    AVATAR = '/settings/avatar',
    NAME = '/settings/name',
    SIGNOUT = '/settings/signout',
    EXPORT_PROP = '/stories/export-prop',
    STORY_EDIT = '/stories/edit/*',
    CHATS = '/chats',
    CHAT = '/chats/chat/*',
    LENSWIZ = '/stories/lens',
    LENSWIZ_START = '/stories/lens/start/*',
    LENSWIZ_POSTER = '/stories/lens/story/*',
    LENSWIZ_CLONE = '/stories/lens/clone/*',
    LENSWIZ_VIDEO = '/stories/lens/video/*',
    LENSWIZ_TP = '/stories/lens/touchpoint/*',
    LENSWIZ_SOCIAL = '/stories/lens/social/*',
    LENSWIZ_GIFT = '/stories/lens/gifts/*',
    LENSWIZ_READY = '/stories/lens/ready/*',
    CLOSE = '/close',
    MORE = '/more',
    OTP_CODE = '/otp',
    PRIVACY = '/privacy',
    TOS = '/tos',
    SCENES = '/scenes/*',
    GIFT = '/gifts/gift/*',
    GETCULIOS = '/getculios',
}

export interface NavItem {
    path: Nav;
    title: string;
    short?: string;
    auth?: number;
    creator?: boolean;
    isFullScreen?: boolean;
    showAppBar?: boolean;
    badge?: string | number;
}

enum Auth {
    GUEST = 1,
    ANON = 2,
    AUTH = 4,
}

export const authAll = Auth.ANON | Auth.GUEST | Auth.AUTH;

export const wildCardNav = (path: Nav, key: string): Nav => {
    const pathAsString = path as string;
    if (!pathAsString.endsWith('/*')) return pathAsString as Nav;
    const paths = pathAsString.split('/');
    paths.pop();
    paths.push(key);
    return paths.join('/') as Nav;
};

export const wildCardNavs = (path: Nav, keys: string[]) => {
    return wildCardNav(path, keys.join('/'));
};
